import React, { useState, useEffect } from 'react'
import '../styles/Landing.css'

function Landing() {
  const [backgroundImage, setBackgroundImage] = useState(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    fetch('https://api.yourhood.ge/api/Hero/hero', {
      headers: { 'X-Language': 'ka' }
    })
      .then(r => r.json())
      .then(data => {
        if (data.imageUrl) {
          const img = new Image()
          img.src = data.imageUrl
          img.onload = () => {
            setBackgroundImage(data.imageUrl)
            setTimeout(() => setLoaded(true), 50)
          }
        }
      })
      .catch(() => {})
  }, [])

  const handleScroll = () => {
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div
      className={`landing-container ${loaded ? 'landing-container--loaded' : ''}`}
      style={loaded && backgroundImage ? {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      } : {}}
    >
      {!loaded && <div className="landing-shimmer" />}

      {loaded && (
        <>
          {/* dark overlay for text readability */}
          <div className="landing-overlay" />

          {/* Hero content */}
          <div className="landing-content">
            <p className="landing-eyebrow">YOUR HOOD — {new Date().getFullYear()}</p>
            <h1 className="landing-title">
              <span className="landing-title-line">LUX ხარისხის კოლექციები</span>
            </h1>
          <button className="landing-cta" onClick={handleScroll} style={{ padding: '8px 20px' }}>
              <span>იხილეთ პროდუქცია</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
          </div>

          {/* Scroll indicator */}
          <div className="landing-scroll-indicator">
            <span className="landing-chevron" />
            <span className="landing-chevron" />
            <span className="landing-chevron" />
          </div>
        </>
      )}
    </div>
  )
}

export default Landing